"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserAlreadyExistsError extends client_library_1.ExtendableError {
    constructor() {
        super(`user already exists`);
    }
}
exports.default = UserAlreadyExistsError;
//# sourceMappingURL=UserAlreadyExistsError.js.map